module.exports = __webpack_public_path__ + "static/media/65-iveco.2b316c52.jpg";